import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { get_footermaster } from '../apis/matchmakingapi';

const Contactus = () => {

  const classes = useStyles();

  const [footerData, setFooterData] = React.useState({});

  React.useEffect(() => {
    getdata();
  }, []);

  function getdata() {
    get_footermaster()
      .then((res) => {
        console.log("Fetched footer data:", res);
        if (Array.isArray(res) && res.length > 0) {
          setFooterData(res[0]); // if your API returns an array
        }
      })
      .catch((err) => {
        console.error("Error fetching footer links", err);
      });
  }

  return (
    <div className={classes.main_d}>
      <div className={classes.in_d}>
        <h1>Main Office</h1>
        <h4>Address:</h4>
        <p>{footerData?.addressOffice || ""}</p>
        <h4>Email:</h4>
        <p>{footerData?.emailOffice || ""}</p>
        <h4>WhatsApp:</h4>
        <p>{footerData?.whatsappOffice || ""}</p>
      </div>

    </div>
  )
}
const useStyles = makeStyles((theme) => ({
  main_d: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'thistle',
  },
  in_d: {
    padding: '20px',
    background: 'white',
    borderRadius: '50px',
  }
}));
export default Contactus